export const FETCH_ALL_TODO_LIST = "FETCH_ALL_TODO_LIST";
export const FETCH_COMPLETED_TODO_LIST = "FETCH_COMPLETED_TODO_LIST";
export const FETCH_OPEN_TODO_LIST = "FETCH_OPEN_TODO_LIST";
export const SHOW_SPINNER = "SHOW_SPINNER";
export const HIDE_SPINNER = "HIDE_SPINNER";
export const SHOW_ERROR = "SHOW_ERROR";
export const DELETE_TODO = "DELETE_TODO";
export const MARK_TODO_COMPLETE = "MARK_TODO_COMPLETE";
export const MARK_TODO_OPEN = "MARK_TODO_OPEN";
export const UPDATE_TODO = "UPDATE_TODO";
export const ADD_TODO = "ADD_TODO";
export const SORT_ACTION = "SORT_ACTION";
export const SELECT_ACTION = "SELECT_ACTION";
export const SELECT_ALL_ACTION = "SELECT_ALL_ACTION";
